import type { Size } from "../types";

export interface SpinnerTheme {
  base: string;
  color: string;
  inverseColor: string;
  size: Record<Size, string>;
  buttonSize: Record<Size, string>;
}

export const spinnerTheme: SpinnerTheme = {
  base: "inline animate-spin ",
  color: "fill-[--color500]",
  inverseColor: "fill-[--contrastText]",
  size: {
    xs: "w-4 h-4",
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
    xl: "w-12 h-12",
  },
  buttonSize: {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-5 h-5",
    xl: "w-6 h-6",
  },
};
